/*
 * Rose & Born – cart drawer behaviour (loaded by snippets/cart-drawer.liquid)
 *  - gift wrap per item: line property "Gift wrap: Yes" (+ cart attribute gift_wrap kept in sync)
 *  - "Change size" in the bag: opens a size sheet (from /products/{handle}?view=rb-upsell-card),
 *    swaps the line to the new variant (same quantity + line properties) and re-renders the drawer
 *    (on the cart page: reloads the page).
 *  - Keeps <cart-drawer class="is-empty"> in sync with what is rendered. The theme only removes that class when
 *    adding from a product form, so adding from anywhere else left the header hidden and made trapFocus() throw.
 */
(function () {
  'use strict';
  if (window.__rbCartDrawerInit) return;
  window.__rbCartDrawerInit = true;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function url(key, fallback) {
    return ((window.routes && window.routes[key]) || root() + fallback) + '.js';
  }
  function postJSON(u, body) {
    return fetch(u, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Error');
        return data;
      });
    });
  }

  /* ---------------------------------------------------------------- gift wrap */
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || box.name !== 'attributes[gift_wrap]' || !box.closest('cart-drawer, .rb-cartpage, .rb-cartpage-foot')) return;
    postJSON(url('cart_update_url', 'cart/update'), { attributes: { gift_wrap: box.checked ? 'Yes' : '' } }).catch(function () {
      box.checked = !box.checked;
    });
  });

  // An emptied cart keeps its attributes, so "Gift wrap the order" came back ticked on the next add (Carl 1 Oct).
  // Clear it whenever the cart is empty: on page load (flag from cart-drawer.liquid) and when the last line is removed.
  function clearGiftIfEmpty(cart) {
    if (!cart || cart.item_count !== 0 || !cart.attributes || !cart.attributes.gift_wrap) return;
    postJSON(url('cart_update_url', 'cart/update'), { attributes: { gift_wrap: '' } }).catch(function () {});
  }
  function initGiftReset() {
    if (document.querySelector('cart-drawer[data-rb-gw-stale]')) {
      clearGiftIfEmpty({ item_count: 0, attributes: { gift_wrap: 'Yes' } });
      document.querySelector('cart-drawer[data-rb-gw-stale]').removeAttribute('data-rb-gw-stale');
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) { clearGiftIfEmpty(evt && evt.cartData); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGiftReset);
  else initGiftReset();

  /* ---------------------------------------------------------------- gift wrap per item (Carl 1 Oct) */
  // Each line gets a quiet "Gift wrap" toggle → line property "Gift wrap: Yes" (shows on the order, packing slip and
  // emails). "Wrap everything" marks all lines. The old cart attribute gift_wrap is kept in sync (Yes when any line is
  // wrapped) so anything that still reads it keeps working.
  function lineProps(b) {
    var p = {};
    try { p = JSON.parse(b.dataset.properties || '{}'); } catch (e) {}
    if (!p || typeof p !== 'object' || Array.isArray(p)) p = {};
    return p;
  }
  function giftUpdate(btns, on) {
    if (!btns.length) return;
    var drawer = btns[0].closest('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    // last line first: if two lines merge, the lines before them keep their numbers
    var list = btns.slice().sort(function (a, b) { return (+b.dataset.line) - (+a.dataset.line); });
    var chain = Promise.resolve(), cart = null;
    list.forEach(function (b) {
      chain = chain.then(function () {
        var p = lineProps(b);
        if (on) p['Gift wrap'] = 'Yes'; else delete p['Gift wrap'];
        return postJSON(url('cart_change_url', 'cart/change'), {
          line: +b.dataset.line, quantity: parseInt(b.dataset.quantity, 10) || 1, properties: p,
        }).then(function (c) { cart = c; });
      });
    });
    chain
      .then(function () {
        var any = !!(cart && cart.items && cart.items.some(function (i) { return i.properties && i.properties['Gift wrap']; }));
        return postJSON(url('cart_update_url', 'cart/update'), {
          attributes: { gift_wrap: any ? 'Yes' : '' }, sections: sections, sections_url: window.location.pathname,
        });
      })
      .then(function (data) {
        if (!drawer || !data.sections || typeof drawer.renderContents !== 'function') { window.location.reload(); return; }
        drawer.renderContents(data);
      })
      .catch(function () { window.location.reload(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rb-gift]');
    if (b) {
      e.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;
      giftUpdate([b], b.getAttribute('aria-pressed') !== 'true');
      return;
    }
    var all = e.target.closest && e.target.closest('[data-rb-gift-all]');
    if (all) {
      e.preventDefault();
      var scope = all.closest('cart-drawer') || document.querySelector('cart-items') || document;
      giftUpdate([].filter.call(scope.querySelectorAll('[data-rb-gift]'), function (x) { return x.getAttribute('aria-pressed') !== 'true'; }), true);
    }
  });

  /* ---------------------------------------------------------------- change size */
  var sheet = null, trigger = null;

  function closeSheet(focusBack) {
    if (sheet) sheet.remove();
    sheet = null;
    document.removeEventListener('pointerdown', onOutside, true);
    if (focusBack && trigger && trigger.isConnected) trigger.focus();
  }
  function onOutside(e) {
    if (sheet && !sheet.contains(e.target)) closeSheet(false);
  }

  function openSheet(btn) {
    var inDrawer = !!btn.closest('cart-drawer');
    var inner = inDrawer ? document.querySelector('cart-drawer .drawer__inner') : document.body;
    if (!inner) return;
    closeSheet(false);
    trigger = btn;
    btn.setAttribute('aria-busy', 'true');
    fetch(root() + 'products/' + encodeURIComponent(btn.dataset.handle) + '?view=rb-upsell-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var panel = tpl.content.querySelector('.rb-upsell-card__sizes');
        if (!panel) { window.location.href = btn.dataset.url; return; }
        panel.id = 'RbChangeSize';
        panel.hidden = false;
        panel.classList.add('rb-change-sheet');
        if (!inDrawer) panel.classList.add('rb-change-sheet--page');
        var label = panel.querySelector('.rb-upsell-card__sizes-label');
        if (label && btn.dataset.sheetLabel) label.textContent = btn.dataset.sheetLabel;
        Array.prototype.forEach.call(panel.querySelectorAll('[data-rb-variant]'), function (b) {
          if (b.getAttribute('data-rb-variant') === btn.dataset.variantId) {
            b.setAttribute('aria-current', 'true');
            b.disabled = true;
          }
        });
        var msg = document.createElement('p');
        msg.className = 'rb-change-sheet__msg';
        msg.setAttribute('role', 'status');
        panel.appendChild(msg);

        panel.addEventListener('click', function (e) {
          if (e.target.closest('[data-rb-close]')) { closeSheet(true); return; }
          var size = e.target.closest('[data-rb-variant]');
          if (size && !size.disabled) swap(size.getAttribute('data-rb-variant'), btn, panel, msg);
        });
        panel.addEventListener('keyup', function (e) {
          if (e.key === 'Escape') { e.stopPropagation(); closeSheet(true); }
        });

        inner.appendChild(panel);
        sheet = panel;
        document.addEventListener('pointerdown', onOutside, true);
        var first = panel.querySelector('.rb-upsell-card__size:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      })
      .catch(function () { window.location.href = btn.dataset.url; })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  function swap(variantId, btn, panel, msg) {
    var drawer = btn.closest('cart-drawer');
    var props = {};
    try { props = JSON.parse(btn.dataset.properties || '{}'); } catch (e) {}
    if (!props || typeof props !== 'object' || Array.isArray(props)) props = {}; // Liquid renders an empty hash as []
    var qty = parseInt(btn.dataset.quantity, 10) || 1;
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    panel.classList.add('is-loading');
    msg.textContent = '';

    // 1) add the new size first (if it fails – e.g. sold out – nothing is removed)
    postJSON(url('cart_add_url', 'cart/add'), { items: [{ id: Number(variantId), quantity: qty, properties: props }] })
      // 2) then remove the old line and get the re-rendered drawer back
      .then(function () {
        return postJSON(url('cart_change_url', 'cart/change'), {
          id: btn.dataset.key, quantity: 0, sections: sections, sections_url: window.location.pathname,
        });
      })
      .then(function (data) {
        if (!drawer) { window.location.reload(); return; }
        closeSheet(false);
        if (drawer && data.sections && typeof drawer.renderContents === 'function') drawer.renderContents(data);
        else window.location.reload();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rb-change-size', productVariantId: variantId, cartData: data });
        }
      })
      .catch(function (err) {
        panel.classList.remove('is-loading');
        msg.textContent = (err && err.message) || '';
      });
  }

  /* ---------------------------------------------------------------- is-empty sync */
  function syncEmpty(drawer) {
    var empty = !!drawer.querySelector('.drawer__inner-empty');
    if (drawer.classList.contains('is-empty') !== empty) drawer.classList.toggle('is-empty', empty);
  }
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    syncEmpty(drawer);
    new MutationObserver(function () { syncEmpty(drawer); }).observe(drawer, { childList: true, subtree: true });
  }
  // Cart page: keep the item count in the title current, and reload once the bag is empty to show the full empty
  // state (recently viewed, best sellers). Watches the DOM rather than pub/sub: the theme's cart.js throws before
  // publishing when the last item is removed on the cart page (it tries to focus the drawer's empty state).
  function watchCartPage() {
    var page = document.querySelector('cart-items.rb-cartpage');
    if (!page) return;
    var wasEmpty = page.classList.contains('is-empty');
    function sync() {
      var empty = page.classList.contains('is-empty');
      if (empty && !wasEmpty) { window.location.reload(); return; }
      var count = page.querySelector('.rb-cartpage__count');
      if (!count) return;
      var n = 0;
      Array.prototype.forEach.call(page.querySelectorAll('.rb-line .quantity__input'), function (i) { n += parseInt(i.value, 10) || 0; });
      var label = '(' + n + ')';
      if (n && count.textContent !== label) count.textContent = label; // compare first: writing re-triggers the observer
    }
    new MutationObserver(sync).observe(page, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }
  function init() { watchDrawer(); watchCartPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ---------------------------------------------------------------- Client Care link */
  document.addEventListener('click', function (e) {
    var care = e.target.closest && e.target.closest('[data-rb-care]');
    if (!care) return;
    var open = document.querySelector('.support-sidebar__open-button');
    if (!open) return; // no sidebar on this page: follow the link to the contact page
    e.preventDefault();
    var drawer = care.closest('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    setTimeout(function () { open.click(); }, drawer ? 250 : 0);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rb-change-size]');
    if (!btn) return;
    e.preventDefault();
    openSheet(btn);
  });
})();
/* Just added: when a product is added from the product page, its line in the drawer gets a short Oyster highlight and
   a small "Just added" label (data-added, translated in the snippet), then settles after 4 s. */
(function () {
  function patch() {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.rbAddedPatch) return;
    C.prototype.rbAddedPatch = true;
    var orig = C.prototype.renderContents;
    C.prototype.renderContents = function (state) {
      var key = state && state.key;
      var out = orig.apply(this, arguments);
      if (key) {
        var self = this;
        requestAnimationFrame(function () {
          var esc = window.CSS && CSS.escape ? CSS.escape(key) : key;
          var li = self.querySelector('.rb-line[data-key="' + esc + '"]');
          if (!li) return;
          var body = li.querySelector('.rb-line__body');
          if (body && !body.querySelector('.rb-line__added')) {
            var lab = document.createElement('span');
            lab.className = 'rb-line__added';
            lab.textContent = li.getAttribute('data-added') || '';
            body.insertBefore(lab, body.firstChild);
          }
          li.classList.add('rb-line--new');
          setTimeout(function () { li.classList.add('rb-line--settle'); }, 4000);
        });
      }
      return out;
    };
  }
  if (customElements.get('cart-drawer')) patch(); else customElements.whenDefined('cart-drawer').then(patch);
})();

/* Remove a line: fold it away at once instead of waiting for the server (the re-render follows and replaces it).
   Works in the bag drawer and on the cart page. If the request fails, the theme's re-render brings the line back. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('cart-remove-button');
    if (!btn) return;
    var line = btn.closest('.cart-item');
    if (!line || line.classList.contains('rb-line--out')) return;
    var h = line.offsetHeight;
    line.style.height = h + 'px';
    line.classList.add('rb-line--out');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { line.style.height = '0px'; line.style.paddingTop = '0px'; line.style.paddingBottom = '0px'; line.style.borderBottomWidth = '0px'; });
    });
  }, true);
})();

/* Monogram price lines (_rb_mono_for) follow their item (_rb_mono): same quantity, gone when the item is removed.
   Runs after each bag change when a monogrammed line is (or was) in the bag; drawer re-rendered, cart page reloaded. */
(function () {
  if (window.__rbMonoSync) return;
  window.__rbMonoSync = true;
  var had = false, busy = false;
  function root() { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function present() { return !!document.querySelector('[data-rb-mono], [data-rb-mono-fee]'); }
  function sync() {
    if (busy) return;
    busy = true;
    fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var parents = {}, updates = {}, n = 0;
      cart.items.forEach(function (i) { var k = i.properties && i.properties._rb_mono; if (k) parents[k] = (parents[k] || 0) + i.quantity; });
      cart.items.forEach(function (i) {
        var f = i.properties && i.properties._rb_mono_for;
        if (!f) return;
        var want = parents[f] || 0;
        if (i.quantity !== want) { updates[i.key] = want; n++; }
      });
      if (!n) return null;
      var drawer = document.querySelector('cart-drawer');
      var page = document.querySelector('cart-items.rb-cartpage');
      var body = { updates: updates };
      if (drawer && !page && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      return fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (page) { window.location.reload(); return; }
        if (drawer && data && data.sections && typeof drawer.renderContents === 'function') drawer.renderContents(data);
      });
    }).catch(function () {}).then(function () { busy = false; had = present(); });
  }
  function init() {
    had = present();
    if (had) sync(); // e.g. changed on another tab
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (had || present()) sync(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Bag count rolls up when something is added (Carl 4 Oct, Motion Lab "added in place").
   The cart re-renders #cart-icon-bubble; we compare the new count with the last one we saw. */
(function () {
  var host = document.getElementById('cart-icon-bubble');
  if (!host || !('MutationObserver' in window)) return;
  function n() { var el = host.querySelector('.rbh__bag-n'); return el ? parseInt(el.getAttribute('data-count'), 10) || 0 : 0; }
  var last = n();
  new MutationObserver(function () {
    var now = n();
    if (now > last) {
      var el = host.querySelector('.rbh__bag-n');
      if (el) { el.classList.remove('rb-roll'); void el.offsetWidth; el.classList.add('rb-roll'); }
    }
    last = now;
  }).observe(host, { childList: true, subtree: true });
})();
